"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearData = exports.resetError = exports.setShippingMethodsCountry = exports.setInpostLockerChosen = exports.setPickupPoint = exports.setShippingMethod = exports.setDhlParcelChosen = exports["default"] = exports.fetchPickupPoints = exports.fetchShippingMethods = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _agent = require("@deosite/agent");
var _toolkit = require("@reduxjs/toolkit");
var _mapShippingMethods = _interopRequireDefault(require("@deosite/helpers/mapShippingMethods"));
var _mapPickupPoints = _interopRequireDefault(require("@deosite/helpers/mapPickupPoints"));
var _createParametrizedUrl = _interopRequireDefault(require("@deosite/helpers/createParametrizedUrl"));
var inpostLockerChosenDefault = {
  status: false,
  locker: {
    name: null,
    street: null,
    city: null,
    postcode: null
  }
};
var dhlLockerChosenDefault = {
  name: null,
  street: null,
  city: null,
  postcode: null
};
var initialState = {
  shippingMethods: null,
  pickupPoints: null,
  selectedPickupPoint: null,
  selectedShippingMethod: null,
  loadingPickupPoints: false,
  pickupPointsLoaded: false,
  loadingShippingMethods: false,
  inpostLockerChosen: inpostLockerChosenDefault,
  dhlParcelChosen: null,
  shippingMethodsCountry: null
};

///fetchShippingMethods odsiwezamy obecnie w cart gdy zmienia sie, [getCartId(), token, cart?.items]

var fetchShippingMethods = (0, _toolkit.createAsyncThunk)("shipping/getShippingMethods", /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(arg, thunkApi) {
    var cartId, language, domain, token, country, url, address;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            cartId = arg.cartId, language = arg.language, domain = arg.domain, token = arg.token, country = arg.country;
            url = "/guest-carts/".concat(cartId, "/estimate-shipping-methods");
            if (token) {
              url = "/carts/mine/estimate-shipping-methods";
            }
            address = {
              country_id: country.toUpperCase()
            };
            return _context.abrupt("return", _agent.requests.post(url, {
              address: address
            }, token, {
              language: language,
              domain: domain
            }).then(function (response) {
              return response;
            })["catch"](function (error) {
              return thunkApi.rejectWithValue(error);
            }));
          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
exports.fetchShippingMethods = fetchShippingMethods;
var fetchPickupPoints = (0, _toolkit.createAsyncThunk)("checkout/getPickupPoints", /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(arg, thunkApi) {
    var language, domain, token;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            language = arg.language, domain = arg.domain, token = arg.token;
            return _context2.abrupt("return", _agent.requests.get((0, _createParametrizedUrl["default"])("/deosite/shipping/pickup-points", {
              lang: language
            }), false, token, {
              language: language,
              domain: domain
            }).then(function (response) {
              return response;
            })["catch"](function (error) {
              var _error$response;
              return thunkApi.rejectWithValue((error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data) || error);
            }));
          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function (_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}());
exports.fetchPickupPoints = fetchPickupPoints;
var shippingMethods = (0, _toolkit.createSlice)({
  name: "shippingMethods",
  initialState: initialState,
  reducers: {
    setShippingMethod: function setShippingMethod(state, action) {
      state.selectedShippingMethod = action.payload;
    },
    setPickupPoint: function setPickupPoint(state, action) {
      state.selectedPickupPoint = action.payload;
    },
    setInpostLockerChosen: function setInpostLockerChosen(state, action) {
      state.inpostLockerChosen = action.payload ? action.payload : inpostLockerChosenDefault;
    },
    setDhlParcelChosen: function setDhlParcelChosen(state, action) {
      state.dhlParcelChosen = action.payload ? action.payload : dhlLockerChosenDefault;
    },
    setShippingMethodsCountry: function setShippingMethodsCountry(state, action) {
      state.shippingMethodsCountry = action.payload;
    },
    resetError: function resetError(state) {
      state.error = null;
    },
    clearData: function clearData(state, action) {
      Object.keys(initialState).forEach(function (key) {
        state[key] = initialState[key];
      });
    }
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(fetchShippingMethods.pending, function (state) {
      state.loadingShippingMethods = true;
    });
    builder.addCase(fetchShippingMethods.fulfilled, function (state, action) {
      state.loadingShippingMethods = false;
      state.shippingMethods = (0, _mapShippingMethods["default"])(action.payload.filter(function (method) {
        return method.available;
      }));
    });
    builder.addCase(fetchShippingMethods.rejected, function (state, action) {
      state.loadingShippingMethods = false;
      state.error = action.payload;
    });
    builder.addCase(fetchPickupPoints.pending, function (state) {
      state.loadingPickupPoints = true;
    });
    builder.addCase(fetchPickupPoints.fulfilled, function (state, action) {
      state.loadingPickupPoints = false;
      state.pickupPoints = (0, _mapPickupPoints["default"])(action.payload); //mapPickupPoints(action.payload);
      state.pickupPointsLoaded = true;
    });
    builder.addCase(fetchPickupPoints.rejected, function (state, action) {
      state.loadingPickupPoints = false;
      state.error = action.error.message;
    });
  }
});
var _default = shippingMethods.reducer;
exports["default"] = _default;
var _shippingMethods$acti = shippingMethods.actions,
  setDhlParcelChosen = _shippingMethods$acti.setDhlParcelChosen,
  setShippingMethod = _shippingMethods$acti.setShippingMethod,
  setPickupPoint = _shippingMethods$acti.setPickupPoint,
  setInpostLockerChosen = _shippingMethods$acti.setInpostLockerChosen,
  setShippingMethodsCountry = _shippingMethods$acti.setShippingMethodsCountry,
  resetError = _shippingMethods$acti.resetError,
  clearData = _shippingMethods$acti.clearData;
exports.clearData = clearData;
exports.resetError = resetError;
exports.setShippingMethodsCountry = setShippingMethodsCountry;
exports.setInpostLockerChosen = setInpostLockerChosen;
exports.setPickupPoint = setPickupPoint;
exports.setShippingMethod = setShippingMethod;
exports.setDhlParcelChosen = setDhlParcelChosen;